import React, { PropsWithChildren } from 'react';
import Box from '@mui/material/Box';

const Section: React.FC<PropsWithChildren<{
    title?: string,
    noDivider?: boolean,
    noMargin?: boolean
}>> = ({ children, title, noDivider = false, noMargin = false }) => {

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'row',
                borderTop: noDivider ? 'none' : `1px solid black`,
                m: 0
            }}
        >
            <Box
                sx={{
                    width: 400,
                    flex: '0 0 150px'
                }}
            >
                <Box
                    component='h4'
                    sx={{
                        m: 0,
                        mt: 1,
                        textTransform: 'uppercase',
                        fontWeight: 'normal'
                    }}
                >
                    {title}
                </Box>
            </Box>
            <Box
                sx={{
                    m: 0,
                    mt: 1,
                    mb: noMargin ? 0 : 1,
                    flex: 1
                }}
            >
                {children}
            </Box>
        </Box>
    )
}

export default Section;